import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { persist, createJSONStorage } from "zustand/middleware";
import { createCrossPlatformStorage } from "./storage.adapter";

interface PreferenceState {
  locationsNearbyCount: number;
  _hasHydrated: boolean;
  setLocationsNearbyCount: (count: number) => void;
}

// Type for persisted state
type PersistedPreferenceState = Pick<PreferenceState, "locationsNearbyCount">;

export const usePreferenceStore = create<PreferenceState>()(
  persist(
    immer((set) => ({
      locationsNearbyCount: 5, // Default value
      _hasHydrated: false,
      setLocationsNearbyCount: (count) =>
        set((state) => {
          state.locationsNearbyCount = count;
        }),
    })),
    {
      name: "preference-storage",
      storage: createJSONStorage(() => createCrossPlatformStorage()),
      partialize: (state): PersistedPreferenceState => ({
        locationsNearbyCount: state.locationsNearbyCount,
      }),
      onRehydrateStorage: () => (state) => {
        if (state) {
          state._hasHydrated = true;
        }
      },
    },
  ),
);
